<template>
  <div :class="$style.container">
    <transition
      :name="$style.slideTransition"
    >
      <div
        v-if="open"
        v-on-clickaway="hideList"
        :class="{
          [$style.dropDownListContainer]: true,
          [$style.dropDownAlignRight]: dropDownAlignRight
        }"
      >
        <div
          v-show="!loading && !errorText"
          :class="$style.dropDownListContent"
        >
          <div :class="$style.resultsContainer">
            <div
              v-show="displayOptions.length"
              :class="$style.selectedOptionsListWithAvailableShowing"
            >
              <ul :class="$style.dropDownList">
                <li
                  v-for="option in displayOptions"
                  :key="option.value"
                  :ref="`option:${option.value}`"
                  :data-test-id="`SingleselectDropdown__option:${option.value}`"
                  @click.prevent="handleChange(option)"
                >
                  <label :class="[$style.dropDownRow, $style.label]">
                    <span>{{ option.title }}</span>
                    <span
                      v-if="option.subtitle"
                      :class="$style.dropDownRowValue"
                    >
                      ({{ option.subtitle }})
                    </span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          v-show="loading"
          :class="$style.loadingContainer"
        >
          <LoadingIcon
            :class="$style.loadingIcon"
          />
        </div>
        <div
          v-show="!loading && errorText"
          :class="$style.errorText"
          data-test-id="SingleselectDropdown__errorText"
        >
          {{ errorText }}
        </div>
        <div
          v-if="!loading && totalOptions"
          :class="$style.resultsMessage"
          data-test-id="SingleselectDropdown__resultsMessage"
        >
          Showing {{ options.length }} of {{ totalOptions }}. Search to narrow results.
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import LoadingIcon from 'public/img/icons/loading.svg?inline';

/**
 * @event {{value: Any, name: String}[]} input - value has changed
 * @event close - User has clicked away from the dropdown
 */
export default {
  name: 'SingleselectDropdown',

  components: {
    LoadingIcon,
  },

  mixins: [clickaway],

  props: {
    errorMessage: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
    /**
     * @type {{value: Any, name: String}[]}
     */
    options: {
      type: Array,
      default: () => [],
    },
    totalOptions: {
      type: Number,
      default: undefined,
    },
    /**
     * @type {{value: Any, name: String}}
     */
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    dropDownAlignRight: false,
    maxResultsToShow: 500,
  }),

  computed: {
    displayOptions() {
      return this.unselectedOptions
        .map(option => ({ ...option, checked: false }));
    },

    errorText() {
      if (this.errorMessage) {
        return this.errorMessage;
      }
      if (!this.options.length) {
        return 'No options available';
      }
      return undefined;
    },

    noResultsFound() { return !this.options.length; },

    unselectedOptions() {
      const { value } = (this.value || {});
      if (value) {
        // exclude selected options
        return this.options
          .filter(option => option.value !== value);
      }

      return this.options;
    },
  },

  methods: {
    handleChange(option) {
      this.$emit('input', option);
    },

    hideList() {
      this.$emit('close');
    },
  },
};
</script>

<style module>
@import "../SearchWithMultiSelect/css/MultiselectDropdown.css";

.dropDownListContainer {
  max-width: 100%;
  min-width: 250px;
  width: 100%;
}

.label {
  max-width: 100%;
}
</style>
